import { Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import { useIntercomStoreContext } from '../../../context/contexts';
import { StyledInfoIcon } from '../../styles';

interface IntercomInfoLinkProps {
  title: string;
  tooltipPlacement: TooltipProps['placement'];
  intercomArticleKey: string;
}

// TODO: get rid of this
export const IntercomInfoLink = (props: IntercomInfoLinkProps) => {
  const intercomStore = useIntercomStoreContext();
  const { title, tooltipPlacement, intercomArticleKey } = props;
  return (
    <Tooltip
      title={title}
      placement={tooltipPlacement}
      onClick={(e) => {
        e.stopPropagation();
        intercomStore.showArticleInIntercom(intercomArticleKey);
      }}
    >
      <StyledInfoIcon />
    </Tooltip>
  );
};
